export interface ModuleInfo {
  id: string;
  name: string;
  shortName: string;
  color: string;
  icon: string;
  locked: boolean;
}

export const MODULES: ModuleInfo[] = [
  { id: 'nodo0', name: 'Nodo 0 — El Origen', shortName: 'El Origen', color: '#8B9D83', icon: 'ri-seedling-line', locked: false },
  { id: 'nodo1', name: 'Nodo 1 — Arraigo', shortName: 'Arraigo', color: '#C97B63', icon: 'ri-anchor-line', locked: true },
  { id: 'nodo2', name: 'Nodo 2 — Entorno', shortName: 'Entorno', color: '#8B9D83', icon: 'ri-landscape-line', locked: true },
  { id: 'nodo3', name: 'Nodo 3 — Mente', shortName: 'Mente', color: '#C97B63', icon: 'ri-mind-map', locked: true },
  { id: 'nodo4', name: 'Nodo 4 — Intuición', shortName: 'Intuición', color: '#8B9D83', icon: 'ri-flashlight-line', locked: true },
  { id: 'nodo5', name: 'Nodo 5 — Cuerpo', shortName: 'Cuerpo', color: '#C97B63', icon: 'ri-heart-pulse-line', locked: true },
  { id: 'nodo6', name: 'Nodo 6 — Vínculos', shortName: 'Vínculos', color: '#8B9D83', icon: 'ri-links-line', locked: true },
];

interface ModuleSelectorProps {
  onSelect: (moduleId: string) => void;
  publishedIds: string[];
}

export default function ModuleSelector({ onSelect, publishedIds }: ModuleSelectorProps) {
  return (
    <div className="min-h-screen px-6 py-10" style={{ background: '#0D0F12' }}>
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="mb-10">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-layout-grid-2-line text-[#8B9D83] text-xl" />
            </div>
            <h2 className="text-[#F8F6F3] font-semibold text-xl tracking-tight">Selector de Módulo</h2>
          </div>
          <p className="text-[#F8F6F3]/40 text-sm ml-11">
            Selecciona el módulo que quieres editar o configurar
          </p>
        </div>

        {/* Module grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {MODULES.map((mod) => {
            const isPublished = publishedIds.includes(mod.id);
            return (
              <button
                key={mod.id}
                onClick={() => onSelect(mod.id)}
                className="rounded-2xl p-6 text-left transition-all duration-200 hover:scale-[1.02] cursor-pointer group"
                style={{
                  background: 'rgba(248,246,243,0.04)',
                  border: `1px solid ${isPublished ? `${mod.color}35` : 'rgba(248,246,243,0.08)'}`,
                }}
              >
                <div className="flex items-start justify-between mb-4">
                  <div
                    className="w-10 h-10 flex items-center justify-center rounded-xl"
                    style={{ background: `${mod.color}15`, border: `1px solid ${mod.color}30` }}
                  >
                    <i className={`${mod.icon} text-base`} style={{ color: mod.color }} />
                  </div>
                  <span
                    className="text-[10px] uppercase tracking-[2px] px-2.5 py-1 rounded-full"
                    style={isPublished
                      ? { background: `${mod.color}15`, color: mod.color }
                      : { background: 'rgba(248,246,243,0.06)', color: 'rgba(248,246,243,0.30)' }
                    }
                  >
                    {isPublished ? 'Publicado' : 'Borrador'}
                  </span>
                </div>
                <p className="text-[#F8F6F3]/40 text-[10px] uppercase tracking-[2px] mb-1">
                  {mod.id.replace('nodo', 'Nodo ')}
                </p>
                <h3 className="text-[#F8F6F3] font-semibold text-sm">{mod.shortName}</h3>
                <div className="flex items-center gap-1.5 mt-4 text-[#F8F6F3]/30 text-xs group-hover:text-[#8B9D83] transition-colors">
                  <i className="ri-edit-line text-xs" />
                  <span>Editar contenido</span>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
